// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Formatting = t.struct({
    dateFields: t.list(t.String)
});

export const getDefaultState = () =>
    new Formatting({
        dateFields: [
            'deliveryDate'
        ]
    });

export default Formatting;



// WEBPACK FOOTER //
// ./src/reports/mass-channel-customer-follow-up/state/formatting.js